export default function () {
    const windowClient = typeof window !== 'undefined' ? window : null;

    if (windowClient) {
        return windowClient;
    }

    return {};
}
